// Alabama county FIPS codes (3-digit, zero-padded) → county name.
export const AL_COUNTY_NAMES = {
  '001': 'Autauga', '003': 'Baldwin', '005': 'Barbour', '007': 'Bibb',
  '009': 'Blount', '011': 'Bullock', '013': 'Butler', '015': 'Calhoun',
  '017': 'Chambers', '019': 'Cherokee', '021': 'Chilton', '023': 'Choctaw',
  '025': 'Clarke', '027': 'Clay', '029': 'Cleburne', '031': 'Coffee',
  '033': 'Colbert', '035': 'Conecuh', '037': 'Coosa', '039': 'Covington',
  '041': 'Crenshaw', '043': 'Cullman', '045': 'Dale', '047': 'Dallas',
  '049': 'DeKalb', '051': 'Elmore', '053': 'Escambia', '055': 'Etowah',
  '057': 'Fayette', '059': 'Franklin', '061': 'Geneva', '063': 'Greene',
  '065': 'Hale', '067': 'Henry', '069': 'Houston', '071': 'Jackson',
  '073': 'Jefferson', '075': 'Lamar', '077': 'Lauderdale', '079': 'Lawrence',
  '081': 'Lee', '083': 'Limestone', '085': 'Lowndes', '087': 'Macon',
  '089': 'Madison', '091': 'Marengo', '093': 'Marion', '095': 'Marshall',
  '097': 'Mobile', '099': 'Monroe', '101': 'Montgomery', '103': 'Morgan',
  '105': 'Perry', '107': 'Pickens', '109': 'Pike', '111': 'Randolph',
  '113': 'Russell', '115': 'St. Clair', '117': 'Shelby', '119': 'Sumter',
  '121': 'Talladega', '123': 'Tallapoosa', '125': 'Tuscaloosa', '127': 'Walker',
  '129': 'Washington', '131': 'Wilcox', '133': 'Winston',
};

/** Reverse lookup: lowercase county name → FIPS code. */
export const AL_COUNTY_FIPS_BY_NAME = Object.fromEntries(
  Object.entries(AL_COUNTY_NAMES).map(([fips, name]) => [name.toLowerCase(), fips]),
);
